import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../UI/ScrollToTop';
import AccessibilityWidget from '../Accessibility/AccessibilityWidget';
import CookieConsentPopup from '../Cookies/CookieConsentPopup';

const Layout: React.FC = () => {
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={`flex flex-col min-h-screen ${isLoaded ? 'animate-fade-in' : 'opacity-0'}`}>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-primary focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary"
      >
        Sari la conținut
      </a>
      <ScrollToTop />
      <Header />
      <main id="main-content" className="flex-grow" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <AccessibilityWidget />
      <CookieConsentPopup />
    </div>
  );
};

export default Layout;
